import React from "react";
import { Helmet } from "react-helmet-async";
import ResetPasswordForm from "@/components/auth/ResetPasswordForm";

const ResetPassword: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Reset Password | SaunaDip</title>
        <meta name="description" content="Reset your SaunaDip password" />
      </Helmet>
      <ResetPasswordForm />
    </>
  );
};

export default ResetPassword; 